<template>
	<div class="content">	
		<div class="policy-container">
			<div class="policy-header">
				<h1 class="policy-title">产品保修政策</h1>
				<p class="policy-subtitle">感谢您选择我们的产品，请仔细阅读以下保修条款</p>
			</div>
			
			<div class="policy-section">
				<div class="question-card">
					<div class="question-header">
						<van-icon name="question" class="question-icon" />
						<h2 class="question">关于产品保修期</h2>
					</div>
					<div class="answer">
						<p>保修期自产品首次购买日起算，以发票日期为准。如无有效发票，则保修期自产品出厂日起算。</p>
						<p>发票日期晚于产品实际交付日的，保修期自实际交付日起算。但无论如何，产品保修期的起算日最迟不应晚于产品出厂日后第九十一（91）天。</p>
						<p>产品或部件经修理或更换后，在剩余保修期内继续享有保修，剩余保修期不足三（3）个月的按三（3）个月计算，但保修期在一（1）年以下的产品和/或部件，剩余保修期不足三十（30）天的按三十（30）天计算。</p>
					</div>
				</div>
				
				<div class="question-card">
					<div class="question-header">
						<van-icon name="service" class="question-icon" />
						<h2 class="question">如何获得保修服务</h2>
					</div>
					<div class="answer">
						<p>在保修期内，如产品发生不符合保证的性能故障，我们将按本文件提供保修服务，您可直接联系授权服务商（"服务商"）获取保修服务，也可拨打产品服务电话由我们为您安排服务。</p>
						<p>您应向我们指定的或距离您最近的服务商申请服务。除非事先明确需由您承担的费用外，我们将不就保修服务向您收费。</p>
						<p>申请保修时，您应提供清晰、完整和准确的①销售发票和②保修卡，这是您有权获得保修的凭证。</p>
					</div>
				</div>
				
				<div class="question-card">
					<div class="question-header">
						<van-icon name="exchange" class="question-icon" />
						<h2 class="question">更换和退货</h2>
					</div>
					<div class="answer">
						<p>除非另有规定，产品更换或退货由产品销售商负责。只有未经更改的产品方可更换或退货。购买日后十五（15）天内更换或退货的，产品随附物品及包装应一并退还。</p>
						<p>更换下来的产品或部件归至像科技所有，而更换后的产品或部件将成为您的财产。替换产品或部件可能不是新的，但将具有良好的性能，并至少在功能上与原产品或部件等同。</p>
					</div>
				</div>
				
				<div class="question-card">
					<div class="question-header">
						<van-icon name="warning" class="question-icon" />
						<h2 class="question">不保证的范围</h2>
					</div>
					<div class="answer">
						<div class="exclusion-list">
							<div class="exclusion-item">
								<span class="exclusion-number">1</span>
								<span>因误用、意外、改装、不适当的物理或操作环境、自然灾害、电涌及不当维护或保管导致的故障或损坏；</span>
							</div>
							<div class="exclusion-item">
								<span class="exclusion-number">2</span>
								<span>第三方产品、服务或行为导致的故障或损坏；③使用非指定软件造成的故障或损坏；</span>
							</div>
							<div class="exclusion-item">
								<span class="exclusion-number">3</span>
								<span>产品使用过程中发生的脱色、磨损和消耗；</span>
							</div>
						</div>
					</div>
				</div>
				
				<div class="question-card">
					<div class="question-header">
						<van-icon name="manager" class="question-icon" />
						<h2 class="question">使用个人信息</h2>
					</div>
					<div class="answer">
						<p>我们可能会保存、使用并处理您提供的保修问题和联系信息，包括姓名、电话号码、地址和电子邮件地址，仅用于提供规定的服务。</p>
						<p>我们可能会与您联系，进行满意度调查或通知您有关产品召回或安全问题。为此，我们可能会将您的信息发送给我们的相关机构，包括代表我们执行某些业务的实体。我们也可能会依有关法律机构的要求向其披露相关信息。</p>
					</div>
				</div>
				
				<div class="question-card">
					<div class="question-header">
						<van-icon name="balance" class="question-icon" />
						<h2 class="question">责任限制</h2>
					</div>
					<div class="answer">
						<p>如至像科技违约或需承担其他责任，您可要求至像科技赔偿损失。但至像科技的赔偿责任仅限于您的实际直接损失，我们对以下各项不承担任何责任：</p>
						<div class="liability-list">
							<div class="liability-item">
								<van-icon name="clear" class="liability-icon" />
								<span>超出您购买产品实际支付价款的金额；</span>
							</div>
							<div class="liability-item">
								<van-icon name="clear" class="liability-icon" />
								<span>任何有关获得替代货物、技术、服务或权利的成本和费用；</span>
							</div>
							<div class="liability-item">
								<van-icon name="clear" class="liability-icon" />
								<span>数据损坏或丢失；或④使用中断或延迟导致的损失。此责任限制同样适用于产品销售商和服务商。这是至像科技及产品销售商和服务商共同承担的最高赔偿限额。</span>
							</div>
						</div>
						<p class="note">以上责任限制仅在法律允许的范围内适用，不适用于那些依法不能通过合同或其他方式排除或限制的责任。</p>
					</div>
				</div>
			</div>
			
			<div class="policy-footer">
				<p class="footer-text">如有疑问，请联系我们的客服中心</p>
				<van-button type="primary" size="large" class="contact-btn" @click="callCustomerService">
					联系客服
				</van-button>
			</div>
		</div>
	</div>
</template>

<script>	
	export default {
	  name: 'INWPOLICY',	
	  mounted(){	
	    document.title = '产品保修政策';
	  },
	  methods: {
	    callCustomerService() {
	      // 拨打电话号码
	      window.location.href = 'tel:4006600900';
	    }
	  }
	}
</script>

<style scoped>
	.content {
		background-color: #f7f8fa;
		min-height: 100vh;
		padding: 0;
	}
	
	.policy-container {
		max-width: 800px;
		margin: 0 auto;
		padding: 16px;
	}
	
	.policy-header {
		text-align: center;
		margin-bottom: 24px;
		padding: 20px 0;
	}
	
	.policy-title {
		font-size: 22px;
		font-weight: bold;
		color: #323233;
		margin-bottom: 8px;
	}
	
	.policy-subtitle {
		font-size: 14px;
		color: #969799;
	}
	
	.policy-section {
		margin-bottom: 20px;
	}
	
	.question-card {
		background-color: #ffffff;
		border-radius: 12px;
		padding: 16px;
		margin-bottom: 16px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
		border: 1px solid #f0f0f0;
	}
	
	.question-header {
		display: flex;
		align-items: center;
		margin-bottom: 12px;
		padding-bottom: 12px;
		border-bottom: 1px solid #f5f5f5;
	}
	
	.question-icon {
		font-size: 18px;
		color: #1989fa;
		margin-right: 8px;
	}
	
	.question {
		font-size: 16px;
		font-weight: bold;
		color: #323233;
		margin: 0;
	}
	
	.answer {
		font-size: 14px;
		line-height: 1.6;
		color: #646566;
	}
	
	.answer p {
		margin-bottom: 12px;
	}
	
	.answer p:last-child {
		margin-bottom: 0;
	}
	
	.exclusion-list {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}
	
	.exclusion-item {
		display: flex;
		align-items: flex-start;
	}
	
	.exclusion-number {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 20px;
		height: 20px;
		background-color: #f0f0f0;
		border-radius: 50%;
		font-size: 12px;
		flex-shrink: 0;
		margin-right: 8px;
		margin-top: 2px;
	}
	
	.liability-list {
		display: flex;
		flex-direction: column;
		gap: 10px;
		margin: 12px 0;
	}
	
	.liability-item {
		display: flex;
		align-items: flex-start;
	}
	
	.liability-icon {
		font-size: 14px;
		color: #ee0a24;
		margin-right: 8px;
		margin-top: 2px;
		flex-shrink: 0;
	}
	
	.note {
		font-size: 13px;
		color: #969799;
		font-style: italic;
		margin-top: 12px;
	}
	
	.policy-footer {
		background-color: #ffffff;
		border-radius: 12px;
		padding: 20px;
		text-align: center;
		margin-top: 20px;
	}
	
	.footer-text {
		font-size: 14px;
		color: #646566;
		margin-bottom: 16px;
	}
	
	.contact-btn {
		border-radius: 6px;
	}
</style>